// extracted by mini-css-extract-plugin
export default {"text":"add-smt-account_text__Y+MHs"};